export default class OriginModel {
  id!: number;

  descricao!: string;
}
